import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiPartner extends Layout {
    panelPartner: Panel;
    sourceEdiPartner: DataSource;
    textboxNextBatch: Textbox;
    textboxNotes: Textbox;
    textboxtPartnerName: Textbox;
}
